// extracted by css-extract-rspack-plugin
var _1 = "VS2FCJzITE7wX6a4";
export { _1 as "maxValueField" }
// extracted by css-extract-rspack-plugin
var _1 = "VS2FCJzITE7wX6a4";
export { _1 as "maxValueField" }
